export enum CurrencyCode {
	PLN = 'PLN',
}

export enum OfferStatus {
	HISTORY = 'HISTORY',
	QUEUE = 'QUEUE',
	ACTIVE = 'ACTIVE',
	OFFER_EXPIRED = 'OFFER_EXPIRED',
}

export enum OfferType {
	WAGER_BONUS = 'WAGER_BONUS',
	SPORT_BET_FREEBET = 'SPORT_BET_FREEBET',
	TAX_FACTOR_PROMOTION = 'TAX_FACTOR_PROMOTION',
	SPORT_BET_CASHBACK = 'SPORT_BET_CASHBACK',
}

interface BalanceValue {
	amount: number;
	currency: CurrencyCode;
	zero: boolean;
	centsLong: number;
	negativeAmount: boolean;
	positiveAmount: boolean;
	cents: number;
}

interface OfferPlayerInfo {
	imageUrl: string | null;
	rulesPageUrl: string | null;
	playerInfo: string | null;
	offerCode: string | null;
}

export interface BetSlipConditions {
	slipRegisterMethods?: number[];
	slipBetTypes?: number[];
	slipMinStake?: number;
	slipMaxStake?: number;
	slipMaxNumberOfOutcomes?: number;
	slipMinNumberOfOutcomes?: number;
	combinationMinOdds?: number;
	combinationMaxOdds?: number;
	combinationMinNumberOfOutcomes?: number;
	outcomeMinOdds?: number;

	outcomeAllInCategoryIds?: number[];
	outcomeAllInEventIds?: number[];
	outcomeAllInEventTypes?: number[];
	outcomeAllInGameTypes?: number[];

	outcomeNoneInCategoryIds?: number[];
	outcomeNoneInEventIds?: number[];
	outcomeNoneInEventTypes?: number[];
	outcomeNoneInGameTypes?: number[];

	outcomeOneInCategoryIds?: number[];
	outcomeOneInEventIds?: number[];
	outcomeOneInEventTypes?: number[];
	outcomeOneInGameTypes?: number[];
	outcomeAllInSportIds?: number[];
	outcomeOneInSportIds?: number[];
	outcomeAllInParentCategoryIds?: number[];
	outcomeOneInParentCategoryIds?: number[];
}

interface ActivationSource {
	sourceOfferDefinitionId: unknown | null;
	sourceOfferId: unknown | null;
	sourceAdminId: number;
	sourceBetSlipId: unknown | null;
	sourceTransactionId: unknown | null;
	sourceAssignCodeId: unknown | null;
}

export interface EventAdditionalData {
	adminId: number;
	ip: string;
	activationSource: ActivationSource;
	info: string;
	value: number;
}

export interface OfferBase {
	offerName: string;
	nameKey: string;
	descriptionKey: string;
	offerDefinitionId: number;
	customerId: number;
	offerPlayerInfo: OfferPlayerInfo;
	validTo: number;
	currentBonusAmount: number;
	totalToWager: number;
	wageredPercent: number;
	activationTime: number;
	bonusUnlocked: boolean;
	betSlipConditions: BetSlipConditions;
	offerType: OfferType;
	freebetStake?: number;
	offerValue: number;
	offerId: number;
	balanceValue?: BalanceValue;
	offerStatus?: OfferStatus;
	leftToWager?: number;
	maxBonusAmount?: number;
	statusUpdatedOn?: number;
	offerQueueId?: number;
	identifier?: string;
	activationValue?: number;
	eventAdditionalData?: EventAdditionalData;
	bonusValue?: number;
	wagerTimes?: number;
	lockedAmount?: number;
}

export interface Freebet extends OfferBase {
	offerFreebetId: number;
	offerType: OfferType.SPORT_BET_FREEBET;

	freebetStake: number;
	betSlipId?: number;
	betSlipRegDate?: number;
	betSlipConfirmedReturn?: number;
	betSlipStatus?: number;
	sourceId?: number;
	additionalInfo?: string;
}

export interface Bonus extends OfferBase {
	wagerBonusId: number;
	offerType: OfferType.WAGER_BONUS;
	unlockConditions: UnlockConditions;
}

type UnlockConditions = {
	totalSumToUnlock: number;
	sumLeftToUnlock: number;
	totalBetsToUnlock?: number;
	betsLeftToUnlock?: number;
	minimumOddsProduct?: number;
	allowedSlipBetTypes?: number[];
};

export type Offer = Freebet | Bonus;
